import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery: mq } = mediaQueryStyles;
const { BreakpointNames } = constants.breakpoints;

const shareModalRootCss = {
  /**
   * Match GlobalLayout header z-index, otherwise the logo
   * and user dropdown will appear above the modal.
   */
  zIndex: 14,
};

const shareModalContentWrapperCss = {
  [mq.downTo(BreakpointNames.xs)]: {
    maxWidth: "800px",
  },
};

const shareModalFooterCss = {
  display: "flex",
  justifyContent: "flex-end",
};

const shareModalBodyCss = {
  display: "grid",
  gridTemplateColumns: "420px",
  [mq.upTo(BreakpointNames.xs)]: {
    gridTemplateColumns: "1fr",
  },
  placeContent: "center",
  flexGrow: 1,
  margin: "auto",
};

export const shareModalCss = {
  footer: shareModalFooterCss,
  modalContentWrapper: shareModalContentWrapperCss,
  root: shareModalRootCss,
  scrollableBody: shareModalBodyCss,
};
